import { render, staticRenderFns } from "./szStudio.vue?vue&type=template&id=13e626d5&scoped=true"
import script from "./szStudio.vue?vue&type=script&lang=js"
export * from "./szStudio.vue?vue&type=script&lang=js"
import style0 from "./szStudio.vue?vue&type=style&index=0&id=13e626d5&prod&lang=scss&scoped=true"
import style1 from "./szStudio.vue?vue&type=style&index=1&id=13e626d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e626d5",
  null
  
)

export default component.exports